import _ from "lodash";
import ACLStorage from "lib/aclService";
import { PARENT, STAFF, STUDENT } from "Constants/stringConstants";
import { getIsBehaviourRnPModuleConsumptionEnabled } from "./ACLStoreUtils";
import { getIsBehaviourModuleEnabledInModuleSettingsAndRnP } from "./BehaviourUtils";
import {
  BEHAVIOUR_RNP_ACCOUNT_LEVEL_MODULE_SETTING,
  BEHAVIOUR_RNP_PROGRAMME_LEVEL_MODULE_SETTING,
  CAN_VIEW_BEHAVIOUR_TAB_FOR_ALL_STUDENTS_PROGRAMME,
  CAN_VIEW_STUDENT_PROFILE,
} from "Constants/permissionConstants";

const _getContextsFromContextType = ({ contextType, curriculumProgramId }) => {
  switch (contextType) {
    case "CURRICULUM_PROGRAM": {
      return [
        { entityId: curriculumProgramId, entityType: "CURRICULUM_PROGRAM" },
      ];
    }
    default: {
      return [];
    }
  }
};

const _getControlParameterValue = ({
  controlParameterType,
  controlParameter,
  contexts,
}) => {
  if (controlParameterType === "MODULE_SETTINGS") {
    return contexts
      ? ACLStorage.getModuleSettingsValueByContext(controlParameter, contexts)
      : ACLStorage.getModuleSettingsValue(controlParameter);
  }

  return contexts
    ? ACLStorage.getPermissionValueByContext(controlParameter, contexts)
    : ACLStorage.getPermissionValue(controlParameter);
};

export const getCanAccessStudentProfile = ({
  userType,
  curriculumProgramIds = [],
  applyCurriculumContextForProfileCP = false,
}) => {
  const baseAccessConfigs = [
    {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: CAN_VIEW_STUDENT_PROFILE,
      contextType: "CURRICULUM_PROGRAM",
    },
  ];

  // Fetching permission values without context for non-staff users
  if (_.includes([STUDENT, PARENT], userType)) {
    const studentProfileAccessConfig = _.first(baseAccessConfigs);

    return _getControlParameterValue({
      controlParameterType: studentProfileAccessConfig.controlParameterType,
      controlParameter: studentProfileAccessConfig.controlParameter,
    });
  }

  const isBehaviourRnPModuleConsumptionEnabled =
    userType === STAFF && getIsBehaviourRnPModuleConsumptionEnabled();

  const isBehaviourModuleEnabledInAnyCurriculum = !_.isEmpty(
    curriculumProgramIds
  )
    ? _.some(curriculumProgramIds, curriculumProgramId =>
        getIsBehaviourModuleEnabledInModuleSettingsAndRnP(curriculumProgramId)
      )
    : false;

  const behaviourAccessConfigs = [
    // Account level
    {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: BEHAVIOUR_RNP_ACCOUNT_LEVEL_MODULE_SETTING,
      contextType: "CURRICULUM_PROGRAM",
    },
    // Programme level
    {
      controlParameterType: "MODULE_SETTINGS",
      controlParameter: BEHAVIOUR_RNP_PROGRAMME_LEVEL_MODULE_SETTING,
      contextType: "CURRICULUM_PROGRAM",
    },
    {
      controlParameterType: "PERMISSION",
      controlParameter: CAN_VIEW_BEHAVIOUR_TAB_FOR_ALL_STUDENTS_PROGRAMME,
      contextType: "CURRICULUM_PROGRAM",
    },
  ];

  // check for behaviour access only if RnP module consumption is enabled and behaviour module is enabled in any curriculum
  const accessControlConfigs = [
    ...baseAccessConfigs,
    ...(isBehaviourRnPModuleConsumptionEnabled &&
    isBehaviourModuleEnabledInAnyCurriculum
      ? behaviourAccessConfigs
      : []),
  ];

  const resolveConfig = config => {
    if (
      _.isEmpty(curriculumProgramIds) ||
      (!applyCurriculumContextForProfileCP &&
        config.controlParameter === CAN_VIEW_STUDENT_PROFILE)
    ) {
      return _getControlParameterValue({
        controlParameterType: config.controlParameterType,
        controlParameter: config.controlParameter,
      });
    }

    return _.some(curriculumProgramIds, curriculumProgramId =>
      _getControlParameterValue({
        controlParameterType: config.controlParameterType,
        controlParameter: config.controlParameter,
        contexts: _getContextsFromContextType({
          contextType: config.contextType,
          curriculumProgramId,
        }),
      })
    );
  };

  return _.some(accessControlConfigs, resolveConfig);
};
